<template>
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="11-Code" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="D_02.2_Online-Code"
        transform="translate(-768.000000, -533.000000)"
        fill="currentColor"
      >
        <g id="online-code" transform="translate(0.000000, 0.000000)">
          <g id="latest-code" transform="translate(495.000000, 374.000000)">
            <g id="copy-code" transform="translate(19.000000, 156.000000)">
              <g id="Organization-/-File-/-copy-/-24" transform="translate(253.000000, 2.000000)">
                <path
                  d="M14,5 L14,14 L5,14 L5,5 L14,5 L14,5 Z M14,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,14 C4,14.5522847 4.44771525,15 5,15 L14,15 C14.5522847,15 15,14.5522847 15,14 L15,5 C15,4.44771525 14.5522847,4 14,4 Z M2,9 L1,9 L1,2 C1,1.44771525 1.44771525,1 2,1 L9,1 L9,2 L2,2 L2,9 Z"
                  id="Fill"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Copy'
};
</script>
